export interface XAxisReport {
  uuid: string;
  creationDate: string;
  title: string;
}

export interface State {
  reportList: XAxisReport[];
  loading: boolean;
}

const state: State = {
  reportList: [],
  loading: false,
};

export default state;
